import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableFooter from "@material-ui/core/TableFooter";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import CircularProgress from "@material-ui/core/CircularProgress";

import ListItem from "./ListItem";

import SearchBox from "./SearchBox";
import axios from "axios";
import envConfig from "../../bin/env.config";
import store from "../../store/store";

const useStyles = makeStyles((theme) => ({  
  table: {
    minWidth: 350,
    '& tbody>.MuiTableRow-root:hover': {
      background: '#DDD',
    }
  },
  loading: {
    color: theme.palette.secondary.main,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
}));

export default function MergeGroupsSearch(props) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [groups, setGroups] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const skip = page * rowsPerPage;
      const limit = rowsPerPage;
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/groups?orderBy=${orderBy}&order=${order}&limit=${limit}&skip=${skip}`;
      const result = await axios.post(
        url,
        { q: searchText },
        {
          headers: {
            Authorization: JSON.stringify(store.getState().session.token),
          },
        }
      );
      
      setGroups(result.data.data);
      
      // If API returns total count, use it; otherwise estimate from data length
      if (result.data.total !== undefined) {
        setTotalCount(result.data.total);
      } else if (result.data.count !== undefined) {
        setTotalCount(result.data.count);
      } else {
        // Estimate: if we got full page, there might be more
        setTotalCount(result.data.data.length < rowsPerPage ? (page * rowsPerPage + result.data.data.length) : (page + 1) * rowsPerPage + 1);
      }

      setIsLoading(false);
    };

    fetchData();
  }, [searchText, page, rowsPerPage, order, orderBy]);
  const doSearch = (q) => {
    setSearchText(q);
    setPage(0);
  };
  const handleSortClick = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const {currentProductMatchingGroup}=props;
  const doSelect = (productMatchingGroup)=>{
    const r = window.confirm("Do you really want to merge #"+currentProductMatchingGroup.id+" into #"+productMatchingGroup.id+"?"); 
    if(r == true){
      doMerge(productMatchingGroup.id,currentProductMatchingGroup.id)
    }
  }
  const doMerge = (groupId1,groupId2) => {
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/group/merge`;
      // console.log(postData);
      axios
        .post(url, 
          {newId: groupId1, oldId: groupId2},
          {
              headers: {
                'Authorization': JSON.stringify(store.getState().session.token)
              }
          })
        .then((response) => {
          // console.log(response);
          alert('success');
          window.location.reload(false);
          // props.doClose();
        })
        .catch((err) => {
          alert(err);
        });
        
  };
  return (
    <Grid
      className={classes.root}
      container
      alignItems="center"
      justifyContent="center"
    >
      <SearchBox value={searchText} doSearch={doSearch} searchOnChange={false}/>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              
                <TableCell align="center">
                  <TableSortLabel
                    active={orderBy === "group_id"}
                    direction={orderBy === "group_id" ? order : "asc"}
                    onClick={() => handleSortClick("group_id")}
                  >
                    ID
                    {orderBy === "group_id" ? (
                      <span className={classes.visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </span>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              <TableCell align="center">Image</TableCell>
              <TableCell align="left">
                <TableSortLabel
                  active={orderBy === "name"}
                  direction={orderBy === "name" ? order : "asc"}
                  onClick={() => handleSortClick("name")}
                >
                  Name eg.
                  {orderBy === "name" ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell align="left">
                <TableSortLabel
                  active={orderBy === "brand_name"}
                  direction={orderBy === "brand_name" ? order : "asc"}
                  onClick={() => handleSortClick("brand_name")}
                >
                  Brand.
                  {orderBy === "brand_name" ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "size"}
                  direction={orderBy === "size" ? order : "asc"}
                  onClick={() => handleSortClick("size")}
                >
                  Size eg.
                  {orderBy === "size" ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan="6" align="center">
                  <CircularProgress className={classes.loading} />
                  Loading ...
                </TableCell>
              </TableRow>
            ) : (
              <>
                {groups.map((row, i) => (
                  // <span>{row.image_url}</span>
                  (row.id != currentProductMatchingGroup.id)&&
                  <ListItem key={i} productMatchingGroup={row} doSelect={doSelect} />
                ))}
              </>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={6} align="center" style={{ padding: 0 }}>
                <TablePagination
                  component="div"
                  count={totalCount}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Grid>
  );
}
